export default __webpack_public_path__ + "static/media/SaveButton.3c0a7fec.svg";